import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'
import useViewSwitcher from '../../../../library/hooks/switch/useViewSwitcher';
import { UiView, UiGroupHeader, UiGroupContent, UiForm } from '../../../../library/layout/Index';
import DocAttribute from '../../../cmn/docAttribute/DocAttribute';
import SarasTabsSwitch from '../../../../library/repeater/tabs/SarasTabsSwitch';
import SarasViewSwitch from '../../../../library/hooks/switch/SarasViewSwitch';
import TaskShorthandMain from './TaskShorthandMain';

const taskSwitches = [
    { key: "header", val: "Header", isDefault: 1 },
    { key: "additional", val: "Additional Info" }
]

const TaskShortHand = (props)=>{
    const { formObject, viewMap, viewData, dynamicViewData, ...restProps } = props;
    const [formAction, setFormAction] = React.useState({});

    const viewSwitcher = useViewSwitcher("header");

    const dashDocId = dynamicViewData ?dynamicViewData.action.actionParam.dsh_docid:0;
    const dashWrksid = dynamicViewData ?dynamicViewData.action.actionParam.dsh_wrksid:0;
    const dashRowId = dynamicViewData ?dynamicViewData.action.actionParam.dshv_rowId:0;

    const closeModel = () => {
        setFormAction({});
        restProps.onDynamicViewClose();
    }

    const onCancelClick = () => {
        setFormAction({action:'Cancel', counter: (formAction.counter || 0) + 1});
    }

    const onSaveClick = () => {
        setFormAction({action:'Save', counter: (formAction.counter || 0) + 1});
    }

    if (!viewData)
        return (null)

    return(
        <FormDialog dynamicViewData={dynamicViewData} onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", actionFunction: onSaveClick, cancelFunction: onCancelClick, forCancel: "Cancel" }, actionParam:{showModeID:"sh" } }}
            formStyle={{ width: '715px' }}
            contentStyle={{ height: '460px',overflowY: "scroll" }}
            formTitle={<FormTitle formObject={formObject} value='Task Header' />}
            formObject={formObject} >

            <UiView>
                <UiGroupHeader>
                    <SarasTabsSwitch viewSwitcher={viewSwitcher} switches={taskSwitches} />
                </UiGroupHeader>
                <UiGroupContent>
                    <SarasViewSwitch viewSwitcher={viewSwitcher} ctrlKey='header' hideMode='soft' >
                        <UiForm formName="Shorthand">
                            <TaskShorthandMain viewMap={viewMap} 
                            dsh_docid={dashDocId}
                            dsh_wrksid={dashWrksid}
                            dshv_rowId={dashRowId}
                            closeModel={closeModel} formAction={formAction} viewData={viewData.childViews.taskShorthand} />
                        </UiForm>
                    </SarasViewSwitch>

                    <SarasViewSwitch viewSwitcher={viewSwitcher} ctrlKey='additional' hideMode='soft' >
                        <UiForm formName="Additional">
                            <DocAttribute viewMap={viewMap} viewData={viewData.childViews.taskAdditionalInfo} />
                        </UiForm>
                    </SarasViewSwitch>

                </UiGroupContent>
            </UiView>

        </FormDialog>
    )
}

export default withView(TaskShortHand, "taskComp", "")
